// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * THE ONE RULE AKSEL WILL NOT SELL SEPARATELY.
 *
 * Its controls hide text from the eye and keep it for a screen reader with
 * \`.aksel-sr-only\` — which is exactly how \`hideLabel\` works, and this unit
 * hides every label. That class is defined ONLY in \`global/baseline.css\`, and
 * that file also rewrites \`body\`'s font family, size and line height, so
 * importing it would hand the portal's whole typography to Aksel.
 *
 * So the rule is copied here instead. Nine lines, stable since the class was
 * introduced, and without it every hidden label prints on top of the form.
 */
.aksel-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
}

/* Match the one-pixel field outline and surface while Aksel owns size and interaction states. */
.portal-field-action.aksel-button {
  --__axc-button-border-width: 1px;
  background-color: var(--color-surface);
}

/* Compact form labels follow the portal's label scale; inputs stay legible at 16px. */
.portal-text-field--small .aksel-label {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
}

/* Folder paths can be wider than a form. Keep the selected path inside its field. */
.portal-folder-picker .aksel-label {
  width: 100%;
  min-width: 0;
}
.portal-folder-picker[aria-invalid="true"] {
  border-color: var(--color-danger);
}
`, "",{"version":3,"sources":["webpack://./src/flyt/ui/AkselForm/AkselForm.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;;AAEA,gGAAgG;AAChG;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,sFAAsF;AACtF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iCAAiC;AACnC","sourcesContent":["/*\n * THE ONE RULE AKSEL WILL NOT SELL SEPARATELY.\n *\n * Its controls hide text from the eye and keep it for a screen reader with\n * `.aksel-sr-only` — which is exactly how `hideLabel` works, and this unit\n * hides every label. That class is defined ONLY in `global/baseline.css`, and\n * that file also rewrites `body`'s font family, size and line height, so\n * importing it would hand the portal's whole typography to Aksel.\n *\n * So the rule is copied here instead. Nine lines, stable since the class was\n * introduced, and without it every hidden label prints on top of the form.\n */\n.aksel-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  clip-path: inset(50%);\n  border: 0;\n}\n\n/* Match the one-pixel field outline and surface while Aksel owns size and interaction states. */\n.portal-field-action.aksel-button {\n  --__axc-button-border-width: 1px;\n  background-color: var(--color-surface);\n}\n\n/* Compact form labels follow the portal's label scale; inputs stay legible at 16px. */\n.portal-text-field--small .aksel-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n/* Folder paths can be wider than a form. Keep the selected path inside its field. */\n.portal-folder-picker .aksel-label {\n  width: 100%;\n  min-width: 0;\n}\n.portal-folder-picker[aria-invalid=\"true\"] {\n  border-color: var(--color-danger);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
